import React, { useMemo } from 'react';

import classNames from 'classnames';

import { Logo } from '../../../components/general';
import { PageWrapper } from '../../../components/layout/content';

import { PublicEvent, Person, PageError } from '../../../types';
import { getThumbnail, getCreationVideoUrl, getBpWidth } from '../../../utils';

import ShareFooter from './shareFooter';
import VideoDetails from './videoDetails';

interface Props {
  isPreview?: boolean;
  width: number;
  isLoading?: boolean;
  pageError?: PageError;
  title?: string;
  description?: string;
  event: PublicEvent | null;
  person: Person | null;
  videoRef?: React.RefObject<HTMLVideoElement>;
  setPaymentModalState?: React.Dispatch<React.SetStateAction<string | null>>;
}

const ShareVideoUI: React.FC<Props> = (props) => {
  const {
    isPreview = false,
    width,
    isLoading,
    pageError,
    title,
    description,
    event,
    person,
    videoRef,
    setPaymentModalState,
  } = props;

  const { face, creation, videoUrl } = useMemo(() => {
    return {
      face: person?.face,
      creation: person?.creations?.[0],
      videoUrl: getCreationVideoUrl(event, person),
    };
  }, [event, person]);

  const isMobileDevice = useMemo(() => width < getBpWidth('sm'), [width]);

  return (
    <PageWrapper
      type="full-page"
      title={title}
      description={description}
      isLoading={isLoading}
      pageError={pageError}
      className={classNames({
        'px-[5%] pt-[5%]': isMobileDevice,
        'px-[15%] pt-7': !isMobileDevice,
      })}
      noTips
    >
      <div
        className={classNames(
          'flex flex-col py-7 bg-grey-100 text-center rounded-md shadow-grey-1',
          { 'px-5 gap-4': isMobileDevice, 'px-20 gap-8': !isMobileDevice },
        )}
      >
        <Logo withTagLine />

        <h2>
          <b>{face?.name ?? 'Name'}</b> at {event?.name ?? 'Event'}
        </h2>

        <video
          id="video"
          className="w-full aspect-video rounded-md"
          src={videoUrl}
          poster={
            creation?.frameId ? getThumbnail(creation?.frameId) : undefined
          }
          controls
          controlsList="nodownload"
          ref={videoRef}
        />

        <VideoDetails
          event={event}
          person={person}
          videoUrl={videoUrl}
          setPaymentModalState={setPaymentModalState}
          isPreview={isPreview}
          width={width}
        />
      </div>

      <ShareFooter type="share_creation" />
    </PageWrapper>
  );
};

export default ShareVideoUI;
